import Vue from "vue";
import Buefy from "buefy";

import SupplierCarousel from "./App.vue";


Vue.use(Buefy, {
    defaultIconPack: 'fas',
})
Vue.use(SupplierCarousel)

if(document.getElementById("supplierCarouselApp")){
    new Vue({
        render:h=>h(
            SupplierCarousel,{
                props:{
                    dataUrl:document.getElementById("supplierCarouselApp")
                        .getAttribute("dataUrl")
                }
            }
        )
    }).$mount("#supplierCarouselApp")
}